// extracted by mini-css-extract-plugin
export default {"BatchedText":"BatchedText_BatchedText__xx9Ey","BatchedText__typist":"BatchedText_BatchedText__typist__wuJez"};